// CREDITS: https://www.w3schools.com/howto/howto_js_filter_dropdown.asp

export default class DropdownFilter {
  constructor(element) {
    this.element = element
    this.select = element.querySelector('.js-dropdown-filter-select')
    this.input = element.querySelector('.js-dropdown-filter-input')
    this.dropdown = element.querySelector('.js-dropdown-filter-dropdown')
    this.resultInput = element.querySelector('.js-dropdown-filter-result')

    if (!this.dropdown || !this.select || !this.resultInput) {
      return
    }

    this.items = this.dropdown.querySelectorAll('.js-dropdown-filter-items span')

    this.filter = this.filter.bind(this)
    this.onItemClick = this.onItemClick.bind(this)

    this.init()
  }

  init() {
    this.select.addEventListener('click', () => {
      this.element.classList.toggle('is--open')

      if (this.element.classList.contains('is--open')) {
        this.input.focus()
      }
    })

    const self = this
    window.addEventListener('click', function (e) {
      if (!self.element.contains(e.target)) {
        self.element.classList.remove('is--open')
      }
    })

    if (this.input) {
      this.input.addEventListener('keyup', this.filter)
    }

    this.items.forEach((element) => {
      element.addEventListener('click', (e) => {
        this.onItemClick(e.target.parentNode)
      })
    })
  }

  onItemClick(item) {
    const searchString = item.dataset.searchstring
    const value = item.dataset.value
    this.select.innerHTML = searchString

    if (this.resultInput.value === value) {
      this.resultInput.value = ''
      this.select.innerHTML = 'Selecteer'
      this.select.classList.add('is--empty')
    } else {
      this.resultInput.value = value
      this.select.classList.remove('is--empty')
    }

    this.resultInput.dispatchEvent(new CustomEvent('change'))

    this.element.classList.remove('is--open')
  }

  filter() {
    const inputValue = this.input.value.toUpperCase()

    if (inputValue.length > 0) {
      this.dropdown.classList.add('is--filtered')
    } else {
      this.dropdown.classList.remove('is--filtered')
    }

    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i].parentNode
      const searchString = item.dataset.searchstring

      if (searchString.toUpperCase().indexOf(inputValue) > -1) {
        item.classList.add('is--visible')

        if (!item.parentNode.classList.contains('js-dropdown-filter-items')) {
          item.parentNode.parentNode.classList.add('is--visible')
        }
      } else {
        item.classList.remove('is--visible')
      }
    }
  }
}
